import apis from '@/apis';
import { message } from 'antd';

export function getGlobalGuideList() {
  return (dispatch, getState) =>
    apis
      .functionGuideListOnline()
      .then((res) => {
        if (res && res.ret === '0') {
          dispatch({
            type: 'GLOBAL_GUIDE',
            payload: res.data.list,
          });
        } else {
          message.error(res.msg);
        }
      })
      .catch((err) => {
        message.error(err);
      });
}

const initialState = {
  list: [],
};

export default function globalGuide(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'GLOBAL_GUIDE': {
      return { ...state, ...{ list: payload } };
    }
    default: {
      return { ...state };
    }
  }
}
